<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  methods: {
    save() {
      this.$http.put(`/quotations/${this.form.id}`, this.form).then(() => {
        this.$message('', this.$t('app.messages.saveSuccess'))
        this.load()
      })
    },
    copyAs() {
      let employee = JSON.parse(localStorage.getItem('currentEmployee'))
      this.form = {
        ...this.form,
        id: null,
        charges: [],
        summaryCharges: [],
        validPeriod: null,
        quotationNo: null,
        requestById: employee.id,
      }
      this.$router.push({
        name: 'NewB0201',
        params: { quotation: this.form },
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
